export class ResetForgotPasswordDto {
  private readonly email: string;

  public constructor(email: string) {
    this.email = email;
  }
}
